import React, { useEffect, useRef } from "react";
import { useParams } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { getExportSalesOrderPrint } from "./services/exporSalesOrder.services";
import { LoadingPanel } from "../../components/layout/Loading";
import { PRINT_ACCESS } from "../../_contstants/common";
import {
  checkAcessRights,
  formatIndianNumberForQty,
} from "../../_helper/helper";
import { Button } from "@progress/kendo-react-buttons";

const ExportSalesOrderPrint: React.FC = () => {
  const gridRef = useRef<any>(null);
  const dispatch = useAppDispatch();
  const params = useParams();
  const export_sales_order_guid = params?.export_sales_order_guid;
  const isPrintAccess = checkAcessRights("/exportsalesorder", PRINT_ACCESS);

  const loading = useAppSelector((state) => state.exportsalesorder.loading);
  const ExportSalesOrderPrintDetail = useAppSelector(
    (state) => state.exportsalesorder.ExportSalesOrderPrintDetail
  );

  useEffect(() => {
    if (export_sales_order_guid) {
      const handleDriverVisitPrint = async () => {
        const res = await dispatch(
          getExportSalesOrderPrint(export_sales_order_guid)
        );
        if (res.meta.requestStatus === "fulfilled") {
          window.print();
        }
      };
      handleDriverVisitPrint();
    }
  }, [export_sales_order_guid]);

  let totalQty = 0;
  let totalSubTotal = 0;
  let totalTotalKG = 0;

  ExportSalesOrderPrintDetail?.item_group &&
    ExportSalesOrderPrintDetail?.item_group?.length > 0 &&
    ExportSalesOrderPrintDetail?.item_group?.map((group: any) => {
      group?.export_sales_item &&
        group?.export_sales_item?.length > 0 &&
        group?.export_sales_item?.map((item: any) => {
          totalQty += item?.quantity_ctn;
          totalSubTotal += item?.sub_total;
          totalTotalKG += item?.total_kg;
        });
    });

  if (loading) return <LoadingPanel gridRef={gridRef} />;
  return (
    <>
      <div className="container-fluid export-so-print">
        <div className="position-relative no-visible-print-btn text-end pb-2">
          {isPrintAccess && (
            <Button
              style={{ marginRight: 5 }}
              type="button"
              fillMode={"solid"}
              themeColor={"primary"}
              onClick={() => window.print()}
            >
              Print
            </Button>
          )}
        </div>
        <table className="w-100">
          <thead>
            {/* <tr>
              <th colSpan={15}>
                <div className="d-flex gap-1 justify-content-between">
                  <div className="flex-1 d-flex justify-content-end flex-column">
                    <span>PO - {ExportSalesOrderPrintDetail?.pono}</span>
                    <span>{ExportSalesOrderPrintDetail?.po_date}</span>
                  </div>
                  <div className="flex-1 text-center">
                    <h5 className="fw-bold">{ExportSalesOrderPrintDetail?.party_name}</h5>
                  </div>
                  <div className="flex-1 text-end d-flex align-items-end">
                    <span>{ExportSalesOrderPrintDetail?.exp_delivery_date}</span>
                  </div>
                </div>
              </th>
            </tr> */}
            <tr className="bg-whitesmoke">
              <th colSpan={15} className="border-black">
                <h5 className="fw-bold text-center m-1">
                  {ExportSalesOrderPrintDetail?.party_name}
                </h5>
              </th>
            </tr>
            <tr className="border-black bg-whitesmoke">
              <th colSpan={15}>
                <div className="d-flex gap-1 justify-content-between">
                  <div className="flex-1 d-flex justify-content-end flex-column">
                    <span>PO - {ExportSalesOrderPrintDetail?.pono}</span>
                    <span>Date: {ExportSalesOrderPrintDetail?.po_date}</span>
                  </div>
                  {/* <div className="flex-1 text-center"></div> */}
                  <div className="flex-1 text-end d-flex align-items-end">
                    <span>
                      Exp. Delivery Date:{" "}
                      {ExportSalesOrderPrintDetail?.exp_delivery_date}
                    </span>
                  </div>
                </div>
              </th>
            </tr>
            <tr className="text-center">
              <th className="border-black" rowSpan={2}></th>
              <th className="border-black" rowSpan={2}>
                Item Name
              </th>
              <th className="border-black" colSpan={4}>
                Packing
              </th>
              <th className="border-black" rowSpan={2}>
                Qty (CTNS)
              </th>
              <th className="border-black" rowSpan={2}>
                Total KG
              </th>
              <th className="border-black" rowSpan={2}>
                Barcode
              </th>
              <th className="border-black" rowSpan={2}>
                P. Name
              </th>
              <th className="border-black" rowSpan={2}>
                C
              </th>
              <th className="border-black" rowSpan={2}>
                B
              </th>
              <th className="border-black" rowSpan={2}>
                M
              </th>
              <th className="border-black" rowSpan={2}>
                Total
              </th>
              <th className="border-black" rowSpan={2}>
                Sub Total
              </th>
            </tr>
            <tr className="text-center">
              <th className="border-black">S</th>
              <th className="border-black"></th>
              <th className="border-black"></th>
              <th className="border-black">W</th>
            </tr>
          </thead>
          <tbody>
            {ExportSalesOrderPrintDetail?.item_group &&
              ExportSalesOrderPrintDetail?.item_group?.length > 0 &&
              ExportSalesOrderPrintDetail?.item_group?.map(
                (group: any, index: number) => {
                  return (
                    <>
                      <tr key={index}>
                        <td className="border-black"></td>
                        <td className="border-black fw-600">
                          {group?.item_group}
                        </td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                        <td className="border-black"></td>
                      </tr>
                      {group?.export_sales_item &&
                        group?.export_sales_item?.length > 0 &&
                        group?.export_sales_item?.map(
                          (item: any, subIndex: number) => {
                            return (
                              <tr key={subIndex}>
                                <td className="border-black">{subIndex + 1}</td>
                                <td className="border-black">
                                  {item?.product_name}
                                </td>
                                <td className="border-black text-center">
                                  {item?.packing_size}
                                </td>
                                <td className="border-black text-center">
                                  {item?.unit_code}
                                </td>
                                <td className="border-black text-center">X</td>
                                <td className="border-black text-center">
                                  {item?.packing_weight}
                                </td>
                                <td className="border-black text-center">
                                  {item?.quantity_ctn}
                                </td>
                                <td className="border-black text-end">
                                  {formatIndianNumberForQty(item?.total_kg)}
                                </td>
                                <td className="border-black text-center">
                                  {item?.barcode}
                                </td>
                                <td className="border-black">
                                  {item?.user_name}
                                </td>
                                <td className="border-black text-center">
                                  {item?.size_c}
                                </td>
                                <td className="border-black text-center">
                                  {item?.size_b}
                                </td>
                                <td className="border-black text-center">
                                  {item?.size_m}
                                </td>
                                <td className="border-black text-end">
                                  {item?.total || 0}
                                </td>
                                <td className="border-black text-end">
                                  {item?.sub_total?.toFixed(3) || "0.000"}
                                </td>
                              </tr>
                            );
                          }
                        )}
                    </>
                  );
                }
              )}
            <tr className="bg-whitesmoke fw-600">
              <td className="border-black"></td>
              <td className="border-black">TOTAL</td>
              <td className="border-black"></td>
              <td className="border-black"></td>
              <td className="border-black"></td>
              <td className="border-black"></td>
              <td className="border-black text-center">{totalQty || "0"}</td>
              <td className="border-black text-end">
                {formatIndianNumberForQty(totalTotalKG) || "0.000"}
              </td>
              <td className="border-black"></td>
              <td className="border-black"></td>
              <td className="border-black"></td>
              <td className="border-black"></td>
              <td className="border-black"></td>
              <td className="border-black"></td>
              <td className="border-black text-end">
                {formatIndianNumberForQty(totalSubTotal) || "0.000"}
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </>
  );
};

export default ExportSalesOrderPrint;
